import moment from 'moment';

export function getDocumentName(document) {
    if (document) {
        let documentName = document.documentName.replace(/\.[^/.]+$/, "").replace(/[^a-zA-Z0-9]+/g, "-"); // WMCE-42460 Existing Prod - Reports section - In-correct filename while downloading documents.
        let displayDate = document.displayDate;
        displayDate = displayDate.split("T");
        let onlyDate = displayDate[0];
        let bpId = document.bpId;
        let orderId = document.orderId;
        let currentDateTimeStamp = moment().format('YYYYMMDDhhmmss');
        let downloadedPdfName = `${documentName}_${onlyDate}`;
        if (bpId != null) {
            downloadedPdfName = `${downloadedPdfName}_${bpId}`;
        }
        if (orderId != null) {
            downloadedPdfName = `${downloadedPdfName}_${orderId}`;
        }
        downloadedPdfName = `${downloadedPdfName}_${currentDateTimeStamp}`;
        return downloadedPdfName;
    }
}